module.exports = __webpack_public_path__ + "media/icons/menu/event_logo-9edf105ffaad2a2a73d1426579da0ac8.png";